// 迷ったとき用のコイントス。結果より、結果を見たときの気持ちを大事にする。
import React, { useState } from 'react';
import { insertChoice } from './dailyChoices';

type Props = {
  canSave: boolean;   // 有料会員かつログイン中
  userId?: string;
  onBack: () => void;
};

type Feeling = 'relieved' | 'disappointed';

const FEELING_MESSAGE: Record<Feeling, string> = {
  relieved: 'ほっとしたなら、それがあなたの望んでいた答えかもしれません。',
  disappointed: 'がっかりしたなら、本当はもう一方を選びたいのかもしれません。',
};

const card: React.CSSProperties = { background: 'white', borderRadius: '16px', border: '1px solid #fde68a', padding: '20px 16px', marginBottom: '14px', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' };
const input: React.CSSProperties = { width: '100%', padding: '12px 14px', border: '1px solid #e5e7eb', borderRadius: '12px', fontSize: '17px', fontFamily: 'inherit', background: '#f9fafb' };
const bigBtn = (bg: string, color = 'white', border = 'none'): React.CSSProperties => ({
  width: '100%', minHeight: '56px', padding: '14px 16px', borderRadius: '14px', border, background: bg, color,
  fontSize: '18px', fontWeight: 'bold', fontFamily: 'serif', letterSpacing: '1px', cursor: 'pointer',
});
const linkBtn: React.CSSProperties = { background: 'none', border: 'none', color: '#6b7280', fontSize: '14px', cursor: 'pointer', padding: '10px', textDecoration: 'underline' };

export default function CoinToss({ canSave, userId, onBack }: Props) {
  const [a, setA] = useState('');
  const [b, setB] = useState('');
  const [flipping, setFlipping] = useState(false);
  const [result, setResult] = useState<string | null>(null);
  const [feeling, setFeeling] = useState<Feeling | null>(null);

  const ready = a.trim() !== '' && b.trim() !== '' && a.trim() !== b.trim();

  const toss = () => {
    if (!ready) return;
    setFlipping(true); setResult(null); setFeeling(null);
    setTimeout(() => {
      setResult(Math.random() < 0.5 ? a.trim() : b.trim());
      setFlipping(false);
    }, 900);
  };

  const pickFeeling = async (f: Feeling) => {
    setFeeling(f);
    if (canSave && userId && result) {
      await insertChoice(userId, { entry_type: 'coin', suggestion: result, coin_options: [a.trim(), b.trim()], coin_result: result, coin_feeling: f });
    }
  };

  const again = () => { setResult(null); setFeeling(null); };

  return (
    <>
      <style>{`@keyframes kiCoinFlip{0%{transform:rotateY(0)}100%{transform:rotateY(1080deg)}}`}</style>
      <div style={card}>
        <div style={{ fontSize: '19px', fontWeight: 'bold', fontFamily: 'serif', color: '#78350f', textAlign: 'center', marginBottom: '6px' }}>迷ったらコイントス</div>
        <div style={{ fontSize: '13px', color: '#6b7280', textAlign: 'center', marginBottom: '16px' }}>結果より、結果を見たときの気持ちがヒントです</div>

        {!result && !flipping && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '16px' }}>
              <input value={a} onChange={e => setA(e.target.value)} placeholder="たとえば：出かける" maxLength={30} style={input} />
              <div style={{ textAlign: 'center', fontSize: '14px', color: '#9ca3af' }}>か</div>
              <input value={b} onChange={e => setB(e.target.value)} placeholder="たとえば：家にいる" maxLength={30} style={input} />
            </div>
            <button onClick={toss} disabled={!ready} style={{ ...bigBtn(ready ? 'linear-gradient(135deg,#f59e0b,#d97706)' : '#e5e7eb', ready ? 'white' : '#9ca3af'), cursor: ready ? 'pointer' : 'default' }}>コインを投げる</button>
          </>
        )}

        {flipping && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
            <div style={{ width: '88px', height: '88px', borderRadius: '50%', background: 'radial-gradient(circle at 35% 35%,#fde68a,#d97706)', border: '3px solid #b45309', animation: 'kiCoinFlip 0.9s ease-out' }} />
          </div>
        )}

        {result && (
          <>
            <div style={{ textAlign: 'center', fontSize: '14px', color: '#6b7280' }}>コインが選んだのは</div>
            <div style={{ textAlign: 'center', fontSize: '26px', fontWeight: 'bold', fontFamily: 'serif', color: '#78350f', margin: '10px 0 20px', wordBreak: 'break-all' }}>{result}</div>

            {!feeling ? (
              <>
                <div style={{ textAlign: 'center', fontSize: '17px', fontWeight: 'bold', color: '#78350f', marginBottom: '12px' }}>どう感じた？</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                  <button onClick={() => pickFeeling('relieved')} style={bigBtn('#fffbeb', '#78350f', '1px solid #fde68a')}>ほっとした</button>
                  <button onClick={() => pickFeeling('disappointed')} style={bigBtn('#fffbeb', '#78350f', '1px solid #fde68a')}>がっかり</button>
                </div>
              </>
            ) : (
              <>
                <div style={{ background: '#fffbeb', borderRadius: '10px', padding: '12px 14px', fontSize: '15px', color: '#78350f', lineHeight: 1.8, marginBottom: '8px' }}>{FEELING_MESSAGE[feeling]}</div>
                <div style={{ fontSize: '13px', color: '#6b7280', textAlign: 'center', marginBottom: '14px' }}>
                  {canSave ? '気持ちを記録に残しました。' : '気持ちの記録は、プレミアムで残せます。'}
                </div>
                <button onClick={again} style={bigBtn('white', '#78350f', '1px solid #fde68a')}>もう一度投げる</button>
              </>
            )}
          </>
        )}
      </div>
      <div style={{ textAlign: 'center' }}><button onClick={onBack} style={linkBtn}>入口にもどる</button></div>
    </>
  );
}
